// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import MasterService from '@services/masters'

export const getAllGrade = createAsyncThunk('grade/getAllGrade', async (params, { rejectWithValue }) => {
  try {
    const response = await MasterService.getAllGrade(params)
    return { params, data: response.data, totalPages: response.meta.itemCount }
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const getGradeById = createAsyncThunk('grade/getGradeById', async (id) => {
  const response = await MasterService.getGradeById(id)
  return response
})

export const addGrade = createAsyncThunk('grade/addGrade', async (grade, { rejectWithValue }) => {
  try {
    const response = await MasterService.addGrade(grade)
    return response
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const updateGrade = createAsyncThunk('grade/updateGrade', async (grade, { rejectWithValue }) => {
  try {
    const response = await MasterService.updateGrade(grade)
    return response
  } catch (err) {
    rejectWithValue(err.response.data)
  }
})

export const deleteGrade = createAsyncThunk('grade/deleteGrade', async (id, { dispatch, getState }) => {
  await MasterService.deleteGrade(id)
  await dispatch(getAllGrade(getState()?.grades.params))
  return id
})

export const gradeSlice = createSlice({
  name: 'grade',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    individualGrade: null,
    loading: false
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllGrade.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getGradeById.fulfilled, (state, action) => {
        state.individualGrade = action.payload
        state.loading = false
      })
      .addCase(getGradeById.pending, (state, action) => {
        state.individualGrade = action.payload
        state.loading = true
      })
      .addCase(getGradeById.rejected, (state, action) => {
        state.individualGrade = action.payload
        state.loading = false
      })
  }
})

export default gradeSlice.reducer
